import React from 'react';

const SubmitEnroll = () => {
    return (
        <div>
            <h1 className="text-info">Successfully Enrolled!</h1>
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSl4DdqocD5PK7C4qaL7F-qUiLZHwaK6a6BqQ&usqp=CAU" alt="" />
        </div>
    );
};

export default SubmitEnroll;